(function(global, factory) {
	let Vue = Vue || global.Vue;
	Vue.use(factory());
})(window || this, function(global) {
	let Interceptor = {};
	Interceptor.install = function(Vue, options) {
		let _axios = axios || global.axios,
			loginWebView = null;
		Vue.prototype.$ajax = async (options, map) => {
			let netWorkState;
			if (options.showwaiting && mui.os.plus) {
				plus.nativeUI.showWaiting();
			}
			//监测网络
			if (!mui.os.wechat && mui.os.plus) {
				await new Promise((resolve, reject) => {
					mui.plusReady(() => {
						let hasHint = localStorage.getItem("nonetHint");
						if (common.netWorkState() == '未连接网络' || common.netWorkState() == '未知') {
							if (plus.webview.getWebviewById('no-net')) return;
							//只提示一次
							if (hasHint != 1) {
								localStorage.setItem("nonetHint", 1);
								common.openWindow({
									url: '../../public/no-net/no-net.html',
									id: 'no-net'
								});
							}
							netWorkState = true;
							let noNet = plus.webview.getWebviewById('no-net');
							noNet.addEventListener('close', () => {
								plus.webview.currentWebview().reload(false);
							})
							return;
						} else {
							///再次有网,重置提醒
							if (hasHint == 1) {
								localStorage.setItem("nonetHint", 0);
							}
						}
						resolve();
					})
				})
				if (netWorkState) return;
			}
			//监测skin
			localStorage.getItem('skin') && skin();
			let mapping = {
				"method": "type"
			};
			mapping = Object.assign(mapping, map);
			_axios.defaults.baseURL = domain;
			for (let item in mapping) {
				options[item] = options[mapping[item]];
			}
			if (options.type && (options.type.toLowerCase() === 'post' || options.type.toLowerCase() === 'put' || options.type
					.toLowerCase() === 'delete')) {
				options.traditional = true;
				options.headers = Object.assign({
					'Content-Type': 'application/x-www-form-urlencoded',
					'X-XSRF-TOKEN': common.cookies().get('XSRF-TOKEN') || localStorage.getItem('token')
				}, options.headers || {})
			}
			if (!Object.keys(options.headers || {}).length) {
				options.headers = {}
			}
			options.headers.terminal = 'wechat'
			if (options.type && options.type.toLowerCase() === 'get') {
				let token = common.cookies().get('XSRF-TOKEN')
				localStorage.setItem('token', token)
			}
			if (!options.type || ['get', 'delete'].indexOf(options.type && options.type.toLowerCase()) >= 0) {
				options.params = options.data || {}
				options.data - null
			}
			/*
			 *@description {Function} 序列化表单数据
			 *@params {any} data序列化数据
			 *@params {String} origin序序列化层级key
			 *@params {Boolean} isArray 是否为数组下标
			 *@return {String} 序列化成功后字符串
			 *@example
			 * serializeParam({
			 *  list: [{
			 *    title: 'title'
			 *  }]
			 * })
			 * 结果为 list[0].title=title
			 */
			options.serializeParam = (data, origin = '', isArray) => {
				let keys, isDate
				//过滤null
				data = (data === undefined || data === null) ? '' : data
				//过滤Date对象
				isDate = Object.prototype.toString.call(data) === '[object Date]'
				if (typeof data !== 'object' || isDate) {
					if (!origin) return new Error('data must be an Object or Array')
					//Date实例需要转换
					isDate && (data = timeFormat(data, serializeParam.format))
					return `${origin}=${data}&`
				}
				keys = Object.keys(data)
				keys.forEach((key, index) => {
					let obj = data[key]
					let _origin = /\.$/.test(origin) || !origin ? `${origin}` : `${origin}.`
					if (Array.isArray(obj)) {
						//判断是否为基础数据类型,暂不考虑数组内部数据类型不一致,如果为null，我们统一处理
						if (typeof obj[0] !== 'object' || obj[0] === null) {
							return (options.serializeParam.params += origin ? `${_origin}${key}=${obj.toString()}&` :
								`${key}=${obj.toString()}&`)
						}
						options.serializeParam(obj, `${_origin}${key}`, true)
					} else if (Object.prototype.toString.call(obj) === '[object Object]') {
						key = origin ? isArray ? `${origin}[${index}]` : `${_origin}${key}` : `${key}.`
						options.serializeParam(obj, key)
					} else {
						key = origin ? isArray ? `${origin}[${index}]` : `${_origin}${key}` : key
						if (options.serializeParam.params === undefined) {
							options.serializeParam.params = ""
						}
						options.serializeParam.params += options.serializeParam(obj, key)
					}
				})
				return options.serializeParam.params.slice(0, options.serializeParam.params.length - 1)
			}
			//数组序列化
			if (options.traditional && !options.disabledData) {
				options.transformRequest = options.paramsSerializer = (data) => {
					options.serializeParam(data)
					let params = options.serializeParam.params
					options.serializeParam.params = ''
					return encodeURI(params)
					//    let totalData = [];
					//    //遍历数据对象,暂时忽略参数为对象
					//    for(let prefix in param) {
					//        let data =param[prefix];
					//        if(Array.isArray(data)){
					//           data.forEach((value,index) => {
					//               value = typeof value === 'function' ? value() : ( value == null ? "" : value );
					//               totalData[totalData.length] = `${encodeURIComponent(prefix)}=${encodeURIComponent(value)}`;
					//           })
					//        }else {

					//            totalData[totalData.length] = `${encodeURIComponent(prefix)}=${encodeURIComponent(data)}`;
					//        }
					//    }
					//    return `${totalData.join( "&" )}`
				}
			}

			//数据格式转换
			options.transformResponse = (res) => {
				//         if(res.indexOf('.xml')>0){
				//         		localStorage.removeItem('username');
				//         		common.openWindow({
				//		            url : '../../login/app-login/login.html?loginState=exit',
				//		            id : 'login'
				//		        });
				//         		return undefined;
				//         };
				// console.log("返回参数"+res);
				if (typeof res != 'string') {
					return res;
				}
				let _res = JSON.parse(res);
				let transform = (obj, map) => {
					if (!obj || !map) return obj;
					if (Array.isArray(obj)) {
						obj.forEach((item) => {
							//此处递归会损耗一定性能l,如果确认层级，请将此语句注释;
							if (typeof item === 'object') transform(item, map);
							for (let i in map) {
								if (item[map[i]]) item[i] = item[map[i]];
							}
						})
					} else if (Object.prototype.toString.call(obj) === "[object Object]") {
						for (let i in obj) {
							let item = obj[i];
							if (typeof item === 'object') transform(item, map);
							for (let k in map) {
								if (item[map[k]]) item[k] = item[map[k]];
							}
						}
					}
				}
				try {
					if (_res.data && _res.data.data) {
						transform(_res.data.data, _res.data.propertyNamingStrategy);
					}

				} catch (err) {
					console.log(err);
				}
				mui.plusReady(() => {
					plus.nativeUI.closeWaiting();
				})
				return _res;
			}
			options.withCredentials = true
			return _axios(options);
		}
		_axios.interceptors.response.use(async (req) => {
			// if (req && req.status === 200 && req.data.code == '5001') {
			// 	var host = window.location.origin;
			// 	host = host + "/wechat";
			// 	sessionStorage.setItem('backPageUrl', window.location.pathname + window.location.search)
			// 	var url = host + '/page/toonpage/toonpage/toonpage.html?type=real';
			// 	// window.location.href = url;
			// 	return
			// }
			return req
		}, async (err) => {
			const { status } = err.response || {}
			const pathname = window.location.pathname
			if (pathname.includes('login/app-login/app-login.html')) {
				return err;
			}
			// if (status == 401) {
			// 	return common.openWindow({
			// 		url: '../../login/app-login/app-login.html',
			// 		id: 'app-login'
			// 	})
			// }
			if (status == 401) {
				localStorage.removeItem('isLogin')
			}
			return err;
		})
		_axios.interceptors.request.use(async (config) => {
			if (!config.isPower) return config;
			
			let state,
				isLogin,
				loginSwitch = mui.os.wechat ? localStorage.getItem('uid') : localStorage.getItem('username');
			try {
				await new Promise((resolve, reject) => {
						mui.ajax({
							url: `${domain}/api-ouser/mobile/user/getCurrentUser`,
							methods: 'GET',
							success(res) {
								resolve(res);
							},
							error(err) {
								reject(err);
							}
						})
					}).then((res) => {
						if (res.data) {
							isLogin = true;
							localStorage.setItem('isLogin', true);
							if (res.data && res.data.account) {
								localStorage.setItem('accountId', res.data.account.accountId);
							}
							return;
						}
						//超时登出了，我们要自动登录；
						localStorage.setItem('isLogin', false);
						if (loginSwitch) {
							isLogin = false;
							let url = common.getRole('student') ? `${domain}/portal/captcha/generateCaptchaNum.json` :
								`${domain}/workbench/generateCaptchaWithPeriod.json`;
							return new Promise((resolve) => {
								mui.ajax({
									url: url,
									type: 'POST',
									success(res) {
										resolve(res);
									}
								})
							})
						}
					})
					.then((res) => {

						if (!res) return;
						//alert('自动登录了');
						let dataSwitch = mui.os.wechat ? {
							username: localStorage.getItem('uid'),
							password: '',
							login_ct: 'ajax',
							captcha: res.data,
							client: 'wx'
						} : {
							[common.getRole('student') ? 'username' : 'userName']: localStorage.getItem('username') || localStorage.getItem(
								'uid'),
							password: localStorage.getItem('password'),
							login_ct: 'ajax',
							captcha: res.data,
							client: 'app',
							role: common.getRole()
						};
						return new Promise((resolve, reject) => {
							let url = common.getRole('student') ? `${domain}/login` : `${domain}/workbench/login.json`;
							mui.ajax({
								url: url,
								type: 'POST',
								data: dataSwitch,
								success(res) {
									if (!res.success) return
									resolve(res);
								}
							})
						})
					}).then((res) => {
						if (!res) return;
						localStorage.setItem('isLogin', true);
						isLogin = true;
					})
			} catch (err) {
				console.log(err)
			}
			if (!isLogin && !config.stopSkip) {
				common.openWindow({
				    url: '../../login/app-login/app-login.html',
				    id: 'login'
				})
				// 之前的绑定逻辑 start
				// var host = window.location.origin;
				// host = host + "/wechat";
				// var url = host + '/page/login/app-login/app-login.html';
				// mui.ajax({
				// 	url: `${domain}/api-wx/wx/open/redirect/build`,
				// 	methods: 'GET',
				// 	data: {
				// 		url: url
				// 	},
				// 	success(res) {
				// 		if (res.code == 2000) {
				// 			sessionStorage.setItem('backPageUrl', window.location.pathname + window.location.search)
				// 			window.location.href = res.data;
				// 		}
				// 	}
				// })
				// 之前的绑定手机号逻辑 end
				// 新的统一身份认证逻辑 start
				// var host = window.location.origin;
				// host = host + "/wechat";
				// var url = host + '/page/login/wx-account/login.html';
				// mui.ajax({
				// 	url: `${domain}/api-wx/wx/open/redirect/build`,
				// 	methods: 'GET',
				// 	data: {
				// 		url: url
				// 	},
				// 	success(res) {
				// 		if (res.code == 2000) {
				// 			sessionStorage.setItem('backPageUrl', window.location.pathname + window.location.search)
				// 			window.location.href = res.data;
				// 		}
				// 	}
				// })
				// // 新的统一身份认证逻辑 end
				// return;
			}
			//有权限但是不跳转登录页面
			if (!isLogin && config.stopSkip) return;
			//返回配置文件
			return config;
		}, (err) => {
			throw new Error(`请求失败：${err}`);
		})
	}
	return Interceptor;
})
